import {useUserCity} from 'modules/locations/hooks/useUserCity';
import {DEFAULT_CITY_NAME} from 'modules/locations/constants';
import {cityIn} from 'lvovich';
import React from 'react';

export const CityName = React.memo(function CityName({isWineShopList}: {isWineShopList?: boolean}) {
    const userCity = useUserCity();
    const cityName = isWineShopList ? cityIn(userCity?.title || '') : userCity?.title;

    return <>{cityName || DEFAULT_CITY_NAME}</>;
});
